import enterpriseCard from "./enterprisecard";

const emsCards = {
    namespaced: true,
    modules: {
        enterpriseCard
    }
}

export default emsCards;